<script>
import { defaultNames } from '../helpers/constants';
export default {
	data() {
		return {
			categoryTabs: null,
			allCategoryTabs: null
		};
	},
	computed: {
		categoryGroups() {
			return this.$store.getters.expenseCategoryGroups;
		},
		lifeStageData() {
			return this.$store.getters.lifeStageData;
		},
		avatarImg() {
			return this.$store.getters.avatarImg;
		},
		categories() {
			return this.$store.getters.expenseCategories;
		},
		filteredCategories() {
			if (this.categories) {
				return this.categories.filter(category => {
					return !category.isLockedForCurrentStudent;
				});
			}
			return null;
		}
	},
	methods: {
		checkForCategories(forceUpdate) {
			if (!this.categoryGroups.length || forceUpdate) {
				this.$store.dispatch('getExpenseCategoryGroups');
			}
		},
		setCategoryTabs() {
			if (this.categoryGroups.length) {
				const categoryTabs = [];

				this.categoryGroups.forEach(category => {
					let currentCategory = {};
					currentCategory.name = category.name;
					currentCategory.expanded = null;
					currentCategory.budget = 0;
					currentCategory.expenses = 0;
					currentCategory.subcategories = [];
					category.cmsExpenseCategories.forEach(subcategory => {
						if (!subcategory.isLockedForCurrentStudent) {
							let currentSubcategory = {};
							currentSubcategory.name = subcategory.name;
							currentSubcategory.defaultName = subcategory.defaultName;
							currentSubcategory.budget = 0;
							currentSubcategory.expenses = 0;
							currentSubcategory.id = subcategory.expenseCategory_ID;
							if (subcategory.cmsUpperBudgetGuidelines.length > 0) {
								currentSubcategory.minimum = Math.floor(
									(subcategory.cmsUpperBudgetGuidelines[0].minimum / 100) *
										this.netMonthlyIncome
								);
								currentSubcategory.maximum = Math.floor(
									(subcategory.cmsUpperBudgetGuidelines[0].maximum / 100) *
										this.netMonthlyIncome
								);
							}

							if (subcategory.studentExpenseCategoryBudgets.length > 0) {
								let budget = subcategory.studentExpenseCategoryBudgets[0];
								currentSubcategory.budget = budget.budget || 0;
								currentSubcategory.budgetID = budget.id;

								currentCategory.budget += budget.budget;
							}

							currentSubcategory.expenses =
								subcategory.amountSpentForCurrentStudent;
							currentCategory.expenses +=
								subcategory.amountSpentForCurrentStudent;

							currentCategory.subcategories.push(currentSubcategory);
						}
					});

					if (currentCategory.subcategories.length) {
						categoryTabs.push(currentCategory);
					}
				});
				this.allCategoryTabs = categoryTabs;

				this.categoryTabs = categoryTabs
					.map(category => {
						category.subcategories = category.subcategories.filter(
							subcategory =>
								!(
									subcategory.defaultName.includes(defaultNames.AUTO_LOAN) ||
									subcategory.defaultName.includes(defaultNames.MORTGAGE_LOAN)
								)
						);
						return category;
					})
					.filter(category => category.subcategories.length > 0);
			}
		}
	}
};
</script>
